import React, { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container } from 'react-bootstrap';
import Loader from '../../Components/Loader/Loader';
import MainDiv from '../../Components/AddedAdjdiv/MainDiv';
import AddButton from '../../Components/AddButton/AddButton';
import { accessTillSyllabus } from '../../helper/CreateDispatches';
import { serviceConsumer } from '../../network/ServiceConsumer';
import CollaboratorPicker from '../../Components/Modals/OrganizerModel/CollaboratorPicker/CollaboratorPicker';
import SelectCollaborators from '../../Components/Modals/OrganizerModel/CreateFlowCollaborator/SelectCollaborators';
import NewCollaboratorModal from '../../Components/Modals/OrganizerModel/CreateFlowCollaborator/NewCollaboratorModal';
import EditCollaboratorModal from '../../Components/Modals/OrganizerModel/CreateFlowCollaborator/EditCollaboratorModal';

// collaborators added with the type-ahead picker (sponsors keep their own)
const PICKER_TYPES = ["adjudicator", "musician", "examiner"];

const CollaboratorFies = () => {
  const [openCollabModal, setOpenCollabModal] = useState("")
  const [openNewCollabModal, setOpenNewCollabModal] = useState("")
  const [adjucatorIds, setadjucatorIds] = useState([]);
  const [sponserIds, setSponsersIds] = useState([]);
  const [musicianId, setMusicianId] = useState([]);
  const [adj, setAdj] = useState([]);
  const [mus, setmus] = useState([]);
  const [spn, setspn] = useState([]);
  const [loading, setLoading] = useState();
  const [initialRender, setInitialRender] = useState(true);
  const [editCollab, setEditCollab] = useState(null)
  let EventID = localStorage.getItem('ID');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showAdjucator = false

  useEffect(() => {
    accessTillSyllabus(dispatch)
    setInitialRender(false);
    setLoading(true);
    Promise.all([getCollabs("adjudicators", setAdj, setadjucatorIds),
    getCollabs("musicians", setmus, setMusicianId)])
      .then(res => setLoading(false))
      .catch(err => setLoading(false))
  }, [])

  const handleCollabModals = (collabType) => {
    collabType === "sponsor" && setOpenNewCollabModal(collabType)
    setOpenCollabModal(collabType);
  }
  const getCollabs = async (collab, setCollab, setCollabIds) => {
    try {
      !initialRender && setLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/people/${EventID}/${collab}`;
      const response = await serviceConsumer('GET', url);
      setCollab(response.people);
      setCollabIds(response.people.map((men) => men._id));
      !initialRender && setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  const getCollabForDelete = (from) => {
    if (from === 'adjucators') return getCollabs("adjudicators", setAdj, setadjucatorIds)
    else if (from === 'musician') return getCollabs("musicians", setmus, setMusicianId)
    else return getCollabs("sponsors", setspn, setSponsersIds);
  }
  const onDelete = async (id, from) => {
    try {
      // Accommodations are a feis-only concept — no accommodation branch here
      // (the feis-clone leftover called a /feis endpoint with this Oireachtas id).
      if (from === 'adjucators' || from === 'musician' || from === 'sponser') {
        const url = `${process.env.REACT_APP_BASE_URL}/people/${id}/delete/${EventID}`;
        await serviceConsumer('DELETE', url);
        getCollabForDelete(from)
      }
    } catch (error) {
      setLoading(false);
    }
  }
  const onEdit = (collabDetail, from) => {
    setEditCollab({ ...collabDetail, from: from })
  }
  // submitHandler
  const finishHandler = async () => {
    let val = {
      adjudicators: adjucatorIds.filter(item => item != null),
      sponsors: sponserIds.filter(item => item != null),
      musicians: musicianId.filter(item => item != null),
      page: 6,
    };
    try {
      setLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/oireachtas/${EventID}`;
      const response = await serviceConsumer('PUT', url, val);
      if (response.success === true) {
        // Wizard complete — on to final review + Go Live. Draft keys stay
        // armed (the final page's edit icons re-enter the wizard); they are
        // cleared after a successful go-live.
        navigate(`/oireachtas/create/finalOireachtasDetails?id=${EventID}`);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const collaboratorInitialValues = {};

  const getCollabHandler = () => {
    if (openNewCollabModal === "adjudicator") {
      return getCollabs("adjudicators", setAdj, setadjucatorIds)
    } else if (openNewCollabModal === "musician") {
      return getCollabs("musicians", setmus, setMusicianId)
    } else {
      return getCollabs("sponsors", setspn, setSponsersIds)
    }
  }
  return (
    <div className="AboutOrg">
      <Container className="px-0">
        {loading && <Loader />}
        <Formik initialValues={collaboratorInitialValues}>
          {() => (
            <Form className="form form-label-right" autoComplete="off">
              <div className="syllabusMain">
                <div className="">
                  <div className="detailsHeaders">
                    <h4 className="eventPage">Complete collaborators</h4>
                    <p className="eventDescription">Assign adjudicators and musicians.</p>
                  </div>
                  <label className="eventGradeColabLabel">Adjudicators:</label>
                  <br />
                  {adj?.length > 0 ? renderPeopleData(adj, 'adjucators', onDelete, onEdit) : <div>No adjudicators</div>}
                  <AddButton className="plusIconbtn" onClick={() => handleCollabModals("adjudicator")}>Add</AddButton>
                  <br />
                  <label className="eventGradeColabLabel ">Musicians:</label>
                  <br />
                  {mus?.length > 0 ? renderPeopleData(mus, "musician", onDelete, onEdit) : <div>No musicians</div>}
                  <AddButton className="plusIconbtn" onClick={() => handleCollabModals("musician")}>Add</AddButton>
                  <br />
                  <div className="mt-3 mb-5">
                    <button onClick={finishHandler} className="filled"> Finish </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Container>

      {/* type to find someone, then Add; the list below refreshes as each is added */}
      {PICKER_TYPES.includes(openCollabModal) &&
        <CollaboratorPicker
          open
          allowEmail
          type={openCollabModal}
          eventId={localStorage.getItem('ID')}
          kind="feis"
          onAdded={openCollabModal === "adjudicator"
            ? () => getCollabs("adjudicators", setAdj, setadjucatorIds)
            : () => getCollabs("musicians", setmus, setMusicianId)}
          onClose={() => setOpenCollabModal("")}
          // as before, only adjudicators can be added new here
          onAddNew={openCollabModal === "adjudicator"
            ? () => { setOpenCollabModal(""); setOpenNewCollabModal("adjudicator"); }
            : undefined} />}
      {openCollabModal && !PICKER_TYPES.includes(openCollabModal) &&
        <SelectCollaborators
          allowAddNew={openCollabModal === "adjudicator"}
          setOpenCollabModal={setOpenCollabModal}
          openCollabModal={openCollabModal}
          setOpenNewCollabModal={setOpenNewCollabModal}
          getCollab={openCollabModal === "adjudicator"
            ? () => getCollabs("adjudicators", setAdj, setadjucatorIds)
            : () => getCollabs("musicians", setmus, setMusicianId)} />}
      {openNewCollabModal &&
        <NewCollaboratorModal
          from="feis"
          setOpenCollabModal={setOpenCollabModal}
          setOpenNewCollabModal={setOpenNewCollabModal}
          openNewCollabModal={openNewCollabModal}
          getCollab={getCollabHandler} />}

      {editCollab && <EditCollaboratorModal editCollab={editCollab} setEditCollab={setEditCollab} getCollabOnEdit={getCollabForDelete} type="feis" />}
    </div>
  );
};

export default CollaboratorFies;
const renderPeopleData = (people, from, onDelete, onEdit) => {
  return people?.map((item) =>
    <MainDiv
      key={item?._id}
      name={item?.name}
      fname={item?.fname}
      lname={item?.lname}
      location={item?.location}
      accountStatus={item?.accountStatus}
      photo={item?.photo}
      from={from}
      id={item._id}
      onDelete={onDelete}
      item={item}
    />
  )
}
